import { defineMessages } from 'react-intl';

export const displayLanguageSelectMessages = defineMessages({
  noResultsFound: {
    defaultMessage: 'No results found',
    description:
      'Empty state shown in the display language select when no languages are available',
    id: 'TViGd6tEyu',
  },
});
